<template>
    <div ref="container" style="height: 1.3333333333em">
        <font-awesome-layers class="fa-lg">
            <font-awesome-icon :icon="icon" :title="title"></font-awesome-icon>
            <font-awesome-layers-text
                    v-if="showBadge && badge"
                    class="bg-danger text-white fa-sm"
                    style="min-width: 1em; line-height: 1.2em"
                    transform="shrink-8 up-8 right-8"
                    :value="badge"
            ></font-awesome-layers-text>
            <font-awesome-icon
                    v-if="showBadge && !badge"
                    :icon="['fas', 'circle']"
                    :title="title"
                    transform="shrink-10 up-7 right-7"
                    class="text-danger"
            ></font-awesome-icon>
        </font-awesome-layers>
        <span class="sr-only">{{title}}</span>
    </div>
</template>

<script>
    export default {
        name: 'FaIconBadge',
        props: {
            icon: [Object, Array, String],
            title: {
                type: String,
                default: '',
            },
            showBadge: {
                type: Boolean,
                default: true,
            },
            badge: String,
        },
    }
</script>
